import { render } from "./ApprovalContextPanel.vue?vue&type=template&id=5cdb8878"
import script from "./ApprovalContextPanel.vue?vue&type=script&lang=js"
export * from "./ApprovalContextPanel.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "./ApprovalContextPanel.i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Ftmp%2Fbuild_e58f5c89%2Fpackages%2Fbo%2Fsrc%2Fcomponents%2Fclaim%2Fdetails%2Faction%2FApprovalContextPanel.vue&external"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__